import { render } from "./ListeReglementGroupe.vue?vue&type=template&id=797fb674&ts=true"
import script from "./ListeReglementGroupe.vue?vue&type=script&lang=ts"
export * from "./ListeReglementGroupe.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__